import React from 'react';
import Invite from '../../components/Invite/Invite';
import { useParams } from 'react-router-dom';
import OrganizationHomePage from '../../pages/Onboarding/Dashboard';

export default function EmailInvite({
  setSelectedOrgName,
  scrollToSection
}) {
  const { inviteId } = useParams();
  localStorage.setItem('inviteId', inviteId)
  return (
    <div>
      <Invite inviteId={inviteId} setSelectedOrgName={setSelectedOrgName} />
      <OrganizationHomePage
        scrollToSection={scrollToSection}
      />
    </div>
  );
}
